module.exports = __webpack_public_path__ + "img/极坐标柱状图.e5feaf60.png";